import { AbstractDictionary } from "./AbstractDictionary";
export class DicWCCFType extends AbstractDictionary {
  static NAME = "tsadv_DicWCCFType";
  changePosition?: boolean | null;
  changeSalary?: boolean | null;
}
export type DicWCCFTypeViewName = "_base" | "_local" | "_minimal";
export type DicWCCFTypeView<V extends DicWCCFTypeViewName> = V extends "_base"
  ? Pick<
      DicWCCFType,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "startDate"
      | "endDate"
      | "code"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "description1"
      | "description2"
      | "description3"
      | "description4"
      | "description5"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "changePosition"
      | "changeSalary"
    >
  : V extends "_local"
  ? Pick<
      DicWCCFType,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "changePosition"
      | "changeSalary"
    >
  : V extends "_minimal"
  ? Pick<
      DicWCCFType,
      | "id"
      | "langValue"
      | "langValue1"
      | "langValue2"
      | "langValue3"
      | "langValue4"
      | "langValue5"
      | "startDate"
      | "endDate"
      | "code"
    >
  : never;
